import { createSlice } from '@reduxjs/toolkit';

const formSlice = createSlice({
  name: 'form',
  initialState: {
    loading: false,
    success: false,
    error: false,
    errorMessage: '',
    verified: false,
    data: {
      budget: '',
      description: '',
      domain_id: '',
      email: '',
      file: '',
      have_design: false,
      modules: [],
      name: '',
      page_id: '',
      stage: [],
      time_period: '',
      type_id: '',
    },
    fileLoading: false,
    fileSuccess: false,
    fileError: null,
  },
  reducers: {
    formSubmit(state) {
      state.loading = true;
      state.success = false;
      state.error = false;
      state.errorMessage = '';
      state.verified = false;
    },
    formSubmitSuccess(state, { payload }) {
      state.data.page_id = payload.page_id;
      state.data.description = '';
      state.success = true;
      state.loading = false;
      state.verified = true;
    },
    formSubmitError(state, { payload }) {
      state.success = false;
      state.error = true;
      state.errorMessage =
        payload.data?.detail || payload || 'Sorry, something went wrong';
      state.loading = false;
      state.verified = false;
    },
    setFormDescription(state, { payload }) {
      state.data.description = payload.description;
    },
    fileSubmit(state) {
      state.fileLoading = true;
      state.fileError = null;
    },
    fileSubmitSuccess(state) {
      state.fileLoading = false;
      state.fileSuccess = true;
    },
    fileSubmitError(state, { payload }) {
      state.fileLoading = false;
      state.fileError = payload;
    },
  },
});

export const {
  formSubmit,
  formSubmitSuccess,
  formSubmitError,
  setFormDescription,
  fileSubmit,
  fileSubmitSuccess,
  fileSubmitError,
} = formSlice.actions;

export default formSlice.reducer;
